import { render, staticRenderFns } from "./MailTemplateDialog.vue?vue&type=template&id=8520c532&scoped=true&"
import script from "./MailTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./MailTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateDialog.vue?vue&type=style&index=0&id=8520c532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8520c532",
  null
  
)

export default component.exports